import { render, staticRenderFns } from "./DocentesAdd.vue?vue&type=template&id=7829e6e5"
import script from "./DocentesAdd.vue?vue&type=script&lang=js"
export * from "./DocentesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports